/**
 * Created by Mikhail Menshenin on 23.09.2024
 */

const Shields = function () {
    cleverapps.EventEmitter.call(this);

    this.load();
};

Shields.prototype = Object.create(cleverapps.EventEmitter.prototype);
Shields.prototype.constructor = Shields;

Shields.prototype.set = function (amount, silent) {
    this.exceeded = amount > Shields.MAX_SHIELDS;
    this.amount = this.exceeded ? Shields.MAX_SHIELDS : amount;
    this.save();
    if (!silent) {
        this.trigger("change");
    }
};

Shields.prototype.get = function () {
    return this.amount;
};

Shields.prototype.change = function () {
    this.trigger("change");
};

Shields.prototype.load = function () {
    const data = cleverapps.syncedStorage.load("shields");
    this.amount = data ? data.a || 0 : Shields.MAX_SHIELDS;
    this.exceeded = false;
};

Shields.prototype.save = function () {
    cleverapps.syncedStorage.save("shields", this.getInfo());
};

Shields.prototype.getInfo = function () {
    return {
        a: this.amount
    };
};

Shields.MAX_SHIELDS = 3;

cleverapps.InitByFeature["shields"] = function () {
    cleverapps.shields = new Shields();

    cleverapps.eventBus.on("userChanged", () => {
        cleverapps.shields.load();
        cleverapps.shields.change();
    });
};
